/**
 * Налаштування вигляду й набору кнопок власного відеоплеєра. Адмін редагує їх
 * у розділі «Плеєр»; до плеєра вони приходять разом із посиланням на потік.
 */
export interface PlayerSettings {
  /** HEX акценту (смуга прогресу, велика Play, активні пункти) або null — фірмовий колір. */
  accentColor: string | null;
  controls: {
    bigPlay: boolean;
    skip: boolean;
    currentTime: boolean;
    duration: boolean;
    volume: boolean;
    quality: boolean;
    speed: boolean;
    airplay: boolean;
    pip: boolean;
    fullscreen: boolean;
  };
  /** Крок кнопок «назад/вперед» і подвійного дотику, секунди. */
  skipSeconds: number;
  /** Швидкості в меню. */
  speeds: number[];
  /** Висота якості за замовчуванням; 0 — авто. */
  defaultQuality: number;
  /** Пам'ятати на пристрої вибрані якість і швидкість. */
  rememberChoices: boolean;
}

export const PLAYER_DEFAULTS: PlayerSettings = {
  accentColor: null,
  controls: {
    bigPlay: true,
    skip: true,
    currentTime: true,
    duration: true,
    volume: true,
    quality: true,
    speed: true,
    airplay: true,
    pip: true,
    fullscreen: true,
  },
  skipSeconds: 10,
  speeds: [0.75, 1, 1.25, 1.5, 1.75, 2],
  defaultQuality: 0,
  rememberChoices: true,
};

/** 3725 → «1:02:05», 65 → «1:05». */
export function formatTime(sec: number): string {
  if (!Number.isFinite(sec) || sec < 0) return '0:00';
  const s = Math.floor(sec);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = String(s % 60).padStart(2, '0');
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`;
}
